import { Injectable } from '@angular/core';
import { MacroDefinitionDto, MacroGroupDto } from 'webcommon/shared';
import {ApModalService} from 'webcommon/core-ui';
import { ApMacroEditorModalComponent } from './ap-macro-editor-modal.component';

import { MacroService } from '../ap-macro/index';
import { MacroInterfaces } from '../ap-macro/MacroInterfaces';
@Injectable({
  providedIn: 'root',
})
export class ApMacroEditorModalService {
  constructor(
    private apModalService: ApModalService,
  ) { }

  openCreateModal(
    baseId: string,
    macroService: MacroService,
    macroInterfaces: MacroInterfaces,
    defaultMacroGroup: MacroGroupDto | null): Promise<boolean> {
    const title = 'Create a New Macro';
    const action = 'create';

    const macroDefinitionDto = new MacroDefinitionDto();

    const initialState = {
      action,
      baseId,
      macroDefinitionDto,
      macroInterfaces,
      macroService,
      title,
      defaultMacroGroup,
    };
    const p = this.apModalService.showComponentModal(ApMacroEditorModalComponent, {
      class: 'emds-modal-full',
      ignoreBackdropClick: true,
      initialState,
    });
    return p;
  }

  openModifyModal(
    macroDefinitionDto: MacroDefinitionDto,
    baseId: string,
    macroService: MacroService,
    macroInterfaces: MacroInterfaces,
  ): Promise<boolean> {

    const title = 'Modify Macro';
    const action = 'modify';

    const initialState = {
      action,
      baseId,
      macroDefinitionDto,
      macroInterfaces,
      macroService,
      title,
    };
    const p = this.apModalService.showComponentModal(ApMacroEditorModalComponent, {
      class: 'emds-modal-full',
      ignoreBackdropClick: true,
      initialState,
    });
    return p;
  }

  openCloneModal(
    origMacroDefinitionDto: MacroDefinitionDto,
    baseId: string,
    macroService: MacroService,
    macroInterfaces: MacroInterfaces,
  ): Promise<boolean> {

    const title = 'Clone Macro ' + origMacroDefinitionDto.Name;
    const action = 'clone';

    // Make a copy of macro definition minus Id and Name
    // User mus provide a unique name when cloning.
    // A new Id will be assigned when the cloned  macro is saved.
    const macroDefinitionDto: MacroDefinitionDto = (JSON.parse(JSON.stringify(origMacroDefinitionDto)));
    macroDefinitionDto.Id = null;
    macroDefinitionDto.Name = null;

    const initialState = {
      action,
      baseId,
      macroDefinitionDto,
      macroInterfaces,
      macroService,
      title,
    };
    const p = this.apModalService.showComponentModal(ApMacroEditorModalComponent, {
      class: 'emds-modal-full',
      ignoreBackdropClick: true,
      initialState,
    });
    return p;
  }
}
